import * as React from "react";
import { Redirect } from "react-router-dom";
import { routes } from "src/routes";
import { Logos } from "src/theme/objects/Logos";
import { Description, Wrapper } from "./LoginStyled";
import { WrapperMain } from "src/theme/objects/Layout";
import KudosContext from "src/context";
import { GoogleLogin } from "@react-oauth/google";
import { postRequest } from "src/services/http";
import { endpoints } from "src/endpoints";

export class LoginComponent extends React.Component<{}> {
  public static contextType = KudosContext;
  public context!: React.ContextType<typeof KudosContext>;

  public render() {
    const isAuthenticated = !!this.context!.profile;
    return (
      <>
        {isAuthenticated ? (
          <Redirect to={routes.auth} />
        ) : (
          <WrapperMain>
            <Wrapper>
              <Logos />
              <GoogleLogin
                onSuccess={this.responseGoogle}
                onError={() => {
                  this.errorMessage("Login Failed");
                }}
              />
              <Description>
                Tell your co-workers how much you value them any day of the
                year. Give positive feedback about latest success or just say
                thank you.
              </Description>
            </Wrapper>
          </WrapperMain>
        )}
      </>
    );
  }

  private responseGoogle = (resp) => {
    postRequest(endpoints.login, { id_token: resp.credential }).then((r) => {
      localStorage.setItem("KudosAuthToken", r.kudos_auth_token);
      this.context!.fetchProfile();
      if (r.message) {
        this.errorMessage(r.message);
      }
    });
  };

  private errorMessage = (msg) => {
    this.context!.addMessage({
      message: msg,
      type: "error",
      timeToHide: 3,
    });
  };
}
